import classNames from 'classnames';
import {
  checkIfStringIsZeroOrEmpty,
  isNullOrEmpty,
} from '../../../utils/StringUtils/StringUtils';

const DoubleFilter = ({
  title,
  name1,
  value1,
  name2,
  value2,
  type = 'text',
  filter,
  setFilterValue = () => {},
}) => {
  return (
    <div className="text-xs inline-block m-5">
      <div>{title}:</div>
      <div className="relative">
        <input
          value={checkIfStringIsZeroOrEmpty(filter[value1])}
          type={type !== 'number' ? type : 'text'}
          onChange={(e) => setFilterValue(value1, e.target.value, type)}
          className={classNames(
            'outline-none border-b border-blue-800 focus:border-blue-400 px-2',
            type === 'number' ? 'max-w-[4rem]' : 'max-w-[7.5rem]',
            filter[value1] && 'pr-6',
          )}
          placeholder={`${name1}...`}
        />
        {!isNullOrEmpty(filter[value1]) && (
          <button
            type="button"
            onClick={() => setFilterValue(value1, '', type)} // Clear first input
            className="absolute right-1 top-1/2 -translate-y-1/2 text-gray-500 hover:text-gray-700"
          >
            ✕
          </button>
        )}
      </div>
      <div className="relative">
        <input
          value={checkIfStringIsZeroOrEmpty(filter[value2])} // Ensure controlled input with fallback
          type={type !== 'number' ? type : 'text'}
          onChange={(e) => setFilterValue(value2, e.target.value, type)}
          className={classNames(
            'outline-none border-b border-blue-800 focus:border-blue-400 px-2 block',
            type === 'number' ? 'max-w-[4rem]' : 'max-w-[7.5rem]',
            filter[value2] && 'pr-6', // Add padding-right when clear button is present
          )}
          placeholder={`${name2}...`}
        />
        {!isNullOrEmpty(filter[value2]) && (
          <button
            type="button"
            onClick={() => setFilterValue(value2, '', type)} // Clear second input
            className="absolute right-1 top-1/2 -translate-y-1/2 text-gray-500 hover:text-gray-700"
          >
            ✕
          </button>
        )}
      </div>
    </div>
  );
};

export default DoubleFilter;
